import { injectable } from "inversify";
import { Config } from "../../config/config";

export interface Personalizer {
  personalize(customAttributes: any, personalizationJSON: any): any;
}

@injectable()
export class PersonalizerImpl implements Personalizer {
  personalize(customAttributes: { [attr: string]: string }, personalizationJSON: any): any {
    if (customAttributes) {
      customAttributes = { ...customAttributes };
      if (personalizationJSON) {
        Object.keys(personalizationJSON).forEach((personalizationAttr) => {
          const personalizationAttrValue = personalizationJSON[personalizationAttr];
          const personalizationPlaceholder = new RegExp(this.escapeRegExp(Config.placeholder(personalizationAttr)), "g");

          Object.keys(customAttributes).forEach((attr) => {
            customAttributes[attr] = customAttributes[attr].replace(personalizationPlaceholder, personalizationAttrValue);
          });
        });
      }
    }

    return customAttributes;
  }

  private escapeRegExp(str: string) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
}
